import React, { Component } from 'react';
import { connect } from 'shalala';
import { Tabs, Tab } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useStore } from '../../../../../store';

class ComprobantesTypeFilter extends Component {
  handleOnSelectComprobanteFilter = (filter) => {
    const { filters } = this.props.list;

    this.props.listActions.setPartialState({ selectedTab: filter });

    this.props.listActions.paginate({
      ...filters,
      type: filter !== 'todo' ? filter : '',
    });
  };

  render() {
    const { selectedTab } = this.props.list;

    return (
      <Tabs
        defaultActiveKey="todo"
        activeKey={selectedTab}
        onSelect={this.handleOnSelectComprobanteFilter}
      >
        <Tab
          eventKey="todo"
          title={<FontAwesomeIcon icon={['fas', 'list']} />}
        ></Tab>
        <Tab
          eventKey="I"
          title="Ingreso"
        ></Tab>
        <Tab
          eventKey="E"
          title="Egreso"
        ></Tab>
        <Tab
          eventKey="P"
          title="Pago"
        ></Tab>
        <Tab
          eventKey="N"
          title="Nómina"
        ></Tab>
        <Tab
          eventKey="T"
          title="Traslados"
        ></Tab>
      </Tabs>
    );
  }
}

const mapState = (store) => {
  return { list: store.external.receptores.comprobantes.list };
};

const mapActions = (actions) => {
  return { listActions: actions.external.receptores.comprobantes.list };
};

export default connect(useStore, mapState, mapActions)(ComprobantesTypeFilter);
